export enum LegacyCrmDeeplinkCommand {
  IMO2DASH = 'IMO2DASH',
  EMO2DASH = 'EMO2DASH',
  IMO2PZ = 'IMO2PZ',
  EMO2PZ = 'EMO2PZ',
  IMO2ACCESS = 'IMO2ACCESS',
  EMO2ACCESS = 'EMO2ACCESS',
  MO2BASKET = 'MO2BASKET',
  IMO2BASKET = 'IMO2BASKET',
  EMO2BASKET = 'EMO2BASKET',
  IMO2BILL = 'IMO2BILL',
  EMO2BILL = 'EMO2BILL',
  IMO2NEWS = 'IMO2NEWS',
  EMO2NEWS = 'EMO2NEWS',
  IMO2PZAPF2 = 'IMO2PZAPF2',
  APPCRMORDER = 'APPCRMORDER',
  EMO2CUSELECT = 'EMO2CUSELECT',
}

export enum LegacyPortlet {
  DASHBOARD = 'dashboard',
  BILLING = 'billingmanagement',
  ENTITY_ACCESS = 'entityaccessmanagement',
  CUSTOMER_CONTEXT = 'customercontext',
}

/**
 * This array contains mappings of deeplink commands and their associated portlet names.
 * Note, that it is not exhaustive and can be expanded to cover missing commands as needed.
 */
export const DEEPLINK_COMMAND_PORTLET_MAPPINGS: DeeplinkCommandPortletMapping[] = [
  {
    command: LegacyCrmDeeplinkCommand.IMO2DASH,
    portlet: LegacyPortlet.DASHBOARD,
  },
  {
    command: LegacyCrmDeeplinkCommand.EMO2DASH,
    portlet: LegacyPortlet.DASHBOARD,
  },
  {
    command: LegacyCrmDeeplinkCommand.IMO2ACCESS,
    portlet: LegacyPortlet.ENTITY_ACCESS,
  },
  {
    command: LegacyCrmDeeplinkCommand.EMO2ACCESS,
    portlet: LegacyPortlet.ENTITY_ACCESS,
  },
  {
    command: LegacyCrmDeeplinkCommand.IMO2BILL,
    portlet: LegacyPortlet.BILLING,
  },
  {
    command: LegacyCrmDeeplinkCommand.EMO2BILL,
    portlet: LegacyPortlet.BILLING,
  },
  {
    command: LegacyCrmDeeplinkCommand.IMO2NEWS,
    portlet: LegacyPortlet.DASHBOARD,
  },
  {
    command: LegacyCrmDeeplinkCommand.EMO2NEWS,
    portlet: LegacyPortlet.DASHBOARD,
  },
  {
    command: LegacyCrmDeeplinkCommand.EMO2CUSELECT,
    portlet: LegacyPortlet.CUSTOMER_CONTEXT,
  },
];

export interface LegacyCrmDeeplinkConfig {
  command: LegacyCrmDeeplinkCommand;
  queryParams: Record<string, string | undefined>;
}

export interface DeeplinkCommandPortletMapping {
  command: LegacyCrmDeeplinkCommand;
  portlet: LegacyPortlet;
}
